import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";
import { KycField } from '../models/kyc-validation';

@Injectable({
    providedIn: 'root'
})
export class KycService extends BaseRestService {

    readonly KYC_API_URL: string = environment.apiUri + '/dynamic/validation';

    get(): Observable<any> {
        return this.httpClient.get(this.KYC_API_URL,
            { headers: this.headers });
    }

    update(kyc: any): Observable<any> {
        return this.httpClient.put(this.KYC_API_URL, kyc,
            { headers: this.headers });
    }

    getByCustomerType(customerType: string): Observable<any> {
        return this.httpClient.get(this.KYC_API_URL + "/validation-rules?customerType=" + customerType, {
            headers: this.headers
        });
    }

    getValidationRules(customerType: string, group: KycField['group']): Observable<KycField[]> {
        return this.httpClient.get<KycField[]>(this.KYC_API_URL + "/validation-rules?customerType=" + customerType + "&group=" + group, {
            headers: this.headers
        });
    }

    saveValidation(payload: any): Observable<any> {
        return this.httpClient.put(this.KYC_API_URL + '/validation/save', payload, { headers: this.headers });
    }

}
